<template>
  <div class="uploadPhoto">
      <div class="content_wrapper">
          <div class="upload_card">
              <h3 class="uploadTitle">
                  {{$t('uploadTitle')}}
              </h3>
              <p class="uploadTips" style="margin-bottom:20px">
                  {{$t('uploadTips6')}}
              </p>
              <!-- <p class="uploadTips">
                  {{$t('complete3')}}
              </p>
            <p class="uploadTips">
                  {{$t('complete4')}}
              </p>-->
               <!-- <p class="uploadTips">
                  {{$t('uploadTips2')}}
              </p>
              <p class="uploadTips">
                  {{$t('uploadTips3')}}
              </p>  -->
              <div class="photoTips">
                  <p class="photoP">
                      {{$t('photoTips1')}}
                  </p>
                  <p class="photoP">
                      {{$t('photoTips2')}}
                  </p>
                  <p class="photoP">
                      {{$t('photoTips3')}}
                  </p>
                  <p class="photoP">
                      {{$t('photoTips4')}}
                  </p>
                  <p class="photoP">
                      {{$t('photoTips5')}}
                  </p>
              </div>
              <div class="upload_div">
                  <p class="photo_title">
                      {{$t('phototitle1')}}
                  </p>
                  <div class="upload_wrapper">
                    <upload-card :label='$t("cardtitle1")' :before-back="uploadBack1" :type='IdCard1' :photo="photoData.idCard1" @getData="getData"></upload-card>
                    <upload-card :label='$t("cardtitle2")' :before-back="uploadBack2" :type='IdCard2' :photo="photoData.idCard2" @getData="getData"></upload-card>
                    <upload-card :label='$t("cardtitle3")' :before-back="uploadBack3" :type='IdCard3' :photo="photoData.idCard3" @getData="getData"></upload-card>
                  </div>
                  <p class="photo_title">
                      {{$t('phototitle2')}}
                  </p>
                  <div class="upload_wrapper">
                    <upload-card :label='$t("cardtitle4")' :before-back="uploadBack3" type='AddressFile1' :photo="photoData.addressFile1" @getData="getData"></upload-card>
                    <upload-card :label='$t("cardtitle5")' :before-back="uploadBack3" type='AddressFile2' :photo="photoData.addressFile2" @getData="getData"></upload-card>
                    <upload-card :label='$t("cardtitle6")' :before-back="uploadBack3" type='AddressFile3' :photo="photoData.addressFile3" @getData="getData"></upload-card>
                  </div>
              </div>
              <p class="uploadBottomTips">
                  {{$t('uploadBottomTips')}}
                    <!--  -->
                </p>

               <Button type="primary" class="uploadBtn"  @click="back">{{$t('back')}}</Button>
              <Button type="primary" class="uploadBtn"  @click="submit">{{$t('submit')}}</Button>

                
             
          </div>
           
      </div>
    <loading :isSpinShow="loading"></loading>
      
     
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import Config from '../../plugins/config.js'
import UploadCard from '../../components/UploadCard'
import Loading from '@/components/Loading.vue';


export default {
  name: 'Home',
  components: {
      UploadCard,
      Loading
  },
  data(){
    return{
        uploadBack1:require('@/assets/image/upload1.png'),
        uploadBack2:require('@/assets/image/upload2.png'),
        uploadBack3:require('@/assets/image/upload3.png'),
        AddressFile1:'AddressFile1',
        AddressFile2:'AddressFile2',
        AddressFile3:'AddressFile3',
        IdCard1:'IdCard1',
        IdCard2:'IdCard2',
        IdCard3:'IdCard3',
        photoData:{},
        loading:false
    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
        this.getData()
    },
    methods:{
        getData(){
            this.$axios.get('/api/UserInfo/UserFiles')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    this.photoData = Object.assign(res.data.obj[0],{}) 
                    // console.log(this.basicModel)
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => this.$Message.error(err.data.msg))
        },
        back(){
            this.$router.push({ path:'/accountVerify'})
        },
        submit(){
            this.loading = true
            this.$axios.get('/api/UserQuestion/SubmitSendEamil')
            .then(async (res) => {
                if(res.data.status == 1){
                    this.$Message.success(this.$t('success'))
                    this.$router.push({ path:'/accountVerify'})
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => this.$Message.error(err.data.msg))
            .finally(() => this.loading = false)
        }
    }
}
</script>
<style lang="less" scoped>
.uploadPhoto{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    .content_wrapper{
        background-color: #f9fafb;
        border: 1px solid #f0f0f0;
        // padding-top: 100px;
        margin-top: 50px;
    }
    .upload_card{
        background: #ffffff;
        border: 1px solid #f0f0f0;
        padding:30px 16px ;
        .uploadTitle{
            display: block;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
            padding-left: 20px;
            font-size: 18px;
            color: #332c2b;
            font-weight: normal;
        }
        .uploadTitle::before{
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            width: 8px;
            height: 8px;
            background-color: #e32b3a;
            border-radius: 4px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
        }
        .uploadTips{
            color: #8b8b8c;

        }
        .photoTips{
            .photoP{
                line-height: 40px;
                position: relative;
                padding-left: 20px;
                color: #332c2b;
            }
            .photoP::before{
                content: "";
                position: absolute;
                left: 0px;
                top: 50%;
                width: 4px;
                height: 4px;
                background-color: #e32b3a;
                border-radius: 4px;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
            }
        }
    }
    .upload_div{
        .photo_title{
            color: #e32b3a;
            margin: 22px 0 18px;
            font-size: 16px;
        }
        .upload_wrapper{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
        .upload{
            background-image: url(../../assets/image/upload1.png) ;
            width: 30%;
            background-repeat:no-repeat ;
            background-size: 100% 100%;
            min-height: 255px;
        }
    }
    .uploadBtn{
        margin-top: 30px;
        margin-bottom: 20px;
    }
    .closeBtn{
        margin-top: 30px;
    }
    .uploadBottomTips{
        margin-top: 50px;
        color: #8b8b8c;
        padding-left: 12px;
    }
}
</style>
